module.exports = __webpack_public_path__ + "static/img/9.e44cd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/9.png
// module id = lEGG
// module chunks = 1